// extracted by mini-css-extract-plugin
module.exports = {"banner":"EmbeddedForeignContentBanner_banner__dDjaB"};